import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircleIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

const Services = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const toggleService = (index) => {
    setOpenIndex(prevIndex => (prevIndex === index ? null : index));
  };

  const services = t('services.details', { returnObjects: true });

  return (
    <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white mt-4">
      <section className="services-section pt-16 pb-8 pl-8 pr-8 lg:pt-24 lg:pb-12 lg:pl-12 lg:pr-12">
        <h1 className="text-4xl mb-16">{t('services.title')}</h1>
        <div className="grid grid-cols-1 gap-4">
          {services.map((service, index) => (
            <div
              key={index}
              className={`service-item p-6 bg-black rounded-lg border-2 border-white hover:border-red-500 transition duration-300 hover:shadow-xl ${openIndex !== index ? 'cursor-pointer' : 'cursor-default'}`}
              onClick={() => {
                // Se il servizio è chiuso, cliccando ovunque si apre
                if (openIndex !== index) {
                  toggleService(index);
                }
              }}
            >
              {/* Header: sempre cliccabile per aprire/chiudere */}
              <div
                className="cursor-pointer flex items-center mb-2"
                onClick={(e) => {
                  // Impedisce la propagazione del click al container
                  e.stopPropagation();
                  toggleService(index);
                }}
              >
                <ChevronDownIcon
                  className={`h-6 w-6 mr-2 text-red-500 transform transition-transform duration-150 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
                <h2 className="text-lg sm:text-xl md:text-xl lg:text-2xl font-semibold">
                  {service.title}
                </h2>
              </div>
              {/* Contenuto espanso */}
              <div
                className="overflow-hidden transition-all duration-300 ease-in-out"
                style={{ maxHeight: openIndex === index ? '500px' : '0px' }}
              >
                <p className="mt-2 text-lg sm:text-lg md:text-lg lg:text-xl">
                  {service.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Services;
